import Vue from 'vue';
import VueI18n from 'vue-i18n';
import config from './config';
import cookie from './cookie';
import messages from './messages';
import url from '../helpers/url';

Vue.use(VueI18n);

const getLocale = () => {
  const urlLocale = url.getLocale(window.location.pathname);
  const cookieLocale = cookie.locale.get();

  return urlLocale || cookieLocale || config.DEFAULT_LOCALE;
};

const i18n = new VueI18n({
  locale: getLocale(),
  messages,
});

export default i18n;



// WEBPACK FOOTER //
// ./src/i18n/index.js